module.exports = __webpack_public_path__ + "media/images/countrysquared/li-5ba30dc454f41516b172af3e1b264adf.svg";